import { EntityAudit } from "@modernary/mui/components/audit";
import { type RouterOptions, RouterView } from "vue-router";

// Create names so it can substituted in the future
// - These define route names
const names = {
  invoices: "Invoice.Invoices",
  invoiceList: "Invoice.InvoiceList",
  invoiceView: "Invoice.InvoiceView",
  invoiceNew: "Invoice.InvoiceNew",
  invoiceBase: "Invoice.InvoiceBase",
  invoiceAudit: "Invoice.InvoiceAudit",
  invoiceEdit: "Invoice.InvoiceEdit",
};

export { names as invoiceRouteNames };

const invoiceRoutes: RouterOptions["routes"] = [
  {
    path: "/invoice",
    name: names.invoices,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.invoiceList },
    children: [
      {
        path: "list",
        name: names.invoiceList,
        meta: { title: "Invoices" },
        component: () => import("@/views/invoice/InvoiceList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/invoice/InvoiceBase.vue"),
        redirect: { name: names.invoiceNew },
        props: true,
        children: [
          {
            path: "",
            name: names.invoiceNew,
            meta: { title: "New Invoice", isNew: true },
            component: () => import("@/views/invoice/InvoiceEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.invoiceBase,
        component: () => import("@/views/invoice/InvoiceBase.vue"),
        redirect: { name: names.invoiceView },
        children: [
          {
            path: "view",
            name: names.invoiceView,
            meta: { title: "Invoice View" },
            component: () => import("@/views/invoice/InvoiceView.vue"),
          },
          {
            path: "edit",
            name: names.invoiceEdit,
            meta: { title: "Invoice Edit", isForm: true },
            component: () => import("@/views/invoice/InvoiceEdit.vue"),
          },
          {
            path: "activity",
            name: names.invoiceAudit,
            meta: { title: "Invoice Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Invoice" />,
            },
          },
        ],
      },
    ],
  },
];

export default invoiceRoutes;
